










































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Team extends Vue {
  @Prop() readonly source!: any;

  get teamMembers(): any[] {
    if (!this.source || !this.source.teamMembers) {
      return [];
    }
    const filtered = this.source.teamMembers.filter(
      (member: any) => member.name || member.role,
    );
    // Om det är 5 medlemmar, lägg till en tom för att få jämn fördelning (3+3)
    if (filtered.length === 5) {
      return [...filtered, {}];
    }
    return filtered;
  }

  get firstRow(): any[] {
    if (this.teamMembers.length <= 4) {
      return this.teamMembers;
    }
    return this.teamMembers.slice(0, Math.ceil(this.teamMembers.length / 2));
  }

  get secondRow(): any[] {
    if (this.teamMembers.length <= 4) {
      return [];
    }
    return this.teamMembers.slice(Math.ceil(this.teamMembers.length / 2));
  }

  getMemberImageSrc(member: any): string {
    if (member.staticImagePath) {
      return member.staticImagePath;
    }
    if (member.imageBlobId) {
      if (this.isPrint) {
        return `/admin/blob/${member.imageBlobId}`;
      }
      if (this.isShared) {
        const documentId = this.$route.params.DocumentId as string;
        return `/api/shared/${documentId}/blob/${member.imageBlobId}`;
      }
      return `/api/user/blob/${member.imageBlobId}`;
    }
    return '';
  }

  get isShared(): boolean {
    const route = this.$router.currentRoute.name;
    if (!route) {
      return false;
    }
    return route.startsWith('presentation-shared');
  }

  get isPrint(): boolean {
    if (
      !this.$router ||
      !this.$router.currentRoute ||
      !this.$router.currentRoute.name
    ) {
      return false;
    }
    return this.$router.currentRoute.name.endsWith('print');
  }
}
